import React, { useState, useMemo, useEffect } from "react";
import { showLoader } from "@cisco/spaces-dash-lib-redux-store";
import { useDispatch } from "react-redux";
import { LoadingContext } from "../contexts/loadingContext";

export default function LoadingProvider(props) {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { children } = props;
  const contextValue = useMemo(() => ({ loading, setLoading }), [loading, setLoading]);

  useEffect(() => {
    if (loading) {
      dispatch(showLoader({ flag: true, loadingRef: "pd-home" }));
    } else {
      dispatch(showLoader({ flag: false, loadingRef: "pd-home" }));
    }
  }, [loading]);

  return <LoadingContext.Provider value={contextValue}>{children}</LoadingContext.Provider>;
}
